import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import React, { useState, useEffect } from "react";
import { API_STATUS } from '../../constants';
import { GetMainCat } from '../../apis/login/get_main_cat';
import { GetSubCat } from '../../apis/login/get_sub_cat';
import { Link, useParams } from 'react-router-dom';

export default function SingupMainCat() {
    const { userType } = useParams();

    const [MainApi, setMainApi] = useState(API_STATUS);
    const [SubApi, setSubApi] = useState(API_STATUS);
    const [MainCat, setMainCat] = useState([]);
    const [SubCat, setSubCat] = useState([]);
    const [SelCat, setSelCat] = useState('');
    const [step, setStep] = useState(1);
    const [errorMsg, setError] = useState('');

    useEffect(() => {
        if (userType == 'client') {
            GetMainCat(setMainApi);
        } else {
            setStep(2);
            setSelCat('User');
        }
    }, []);

    useEffect(() => {
        if (!MainApi.isError && !MainApi.isLoader) {
            if (MainApi.data != null) {
                let res = MainApi.data;
                if (res['status'] === 1) {
                    setMainCat(res['data']);
                } else if (res['status'] === 2) {
                    setError(res['data']);
                }
            }
        }
        if (MainApi.isError) {
            setError("Network error");
        }
        if (MainApi.isLoader) {
            setError("");
        }
    }, [MainApi]);

    useEffect(() => {
        if (SelCat !== '') {
            GetSubCat(SelCat, setSubApi);
        }
    }, [SelCat]);

    useEffect(() => {
        if (!SubApi.isError && !SubApi.isLoader) {
            if (SubApi.data != null) {
                let res = SubApi.data;
                if (res['status'] === 1) {
                    setSubCat(res['data']);
                } else if (res['status'] === 2) {
                    setError(res['data']);
                }
            }
        }
        if (SubApi.isError) {
            setError("Network error");
        }
        if (SubApi.isLoader) {
            setError("");
        }
    }, [SubApi]);


    return <div>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />
        <div className="container px-4 text-center">
            <div className="row justify-content-center pb-100 pt-100">
                <div className="col-md-3 d-none d-md-block">
                    <img src={signImg} alt='' width={350} />
                </div>
                <div className="col-md-8">
                    <div className="card bg-white shadow py-3">
                        <div className="card-body">
                            <div className="row justify-content-center" style={{ paddingBottom: 40 }}>
                                <img src={logo} alt='' style={{ width: 275 }} /><br />
                                <h4 style={{ fontSize: 24, paddingTop: 20 }}>Signup as {SelCat}</h4>
                                {
                                    SelCat !== "" &&
                                    <div style={{ color: "#727272", fontSize: 18, paddingTop: 7 }}>Select Your Category</div>
                                }
                                {
                                    errorMsg !== "" &&
                                    <div style={{ color: 'red', fontSize: 18, paddingTop: 7 }}>{errorMsg}</div>
                                }
                            </div>

                            {
                                MainCat !== null && MainCat.length > 0 && step === 1 &&
                                <ul className="signup-category" style={{ paddingBottom: 20 }}>
                                    {
                                        MainCat.map((item, i) =>
                                            <li key={item.c_id}>
                                                <button
                                                    onClick={() => {
                                                        setStep(2);
                                                        setSelCat(item.c_title);
                                                    }}
                                                    className={'btn ' + item.c_color}>{item.c_title}</button>
                                            </li>
                                        )
                                    }
                                </ul>
                            }

                            {
                                SubCat !== null && SubCat.length > 0 && step === 2 &&
                                <ul className="signup-category" style={{ paddingBottom: 20 }}>
                                    {
                                        SubCat.map((item, i) =>
                                            <li key={item.sc_id}>
                                                <a
                                                    href={'/signup/' + SelCat + '/' + item.sc_title.replaceAll("/", "-")}
                                                    className={'btn btn-secondary'}>{item.sc_title}</a>
                                            </li>
                                        )
                                    }

                                </ul>
                            }

                            {
                                step === 2 &&
                                <Link to={'/pre_signup'}
                                    className='btn btn-sm btn-danger'>Back</Link>
                            }

                        </div>
                    </div>

                    {
                        step === 1 &&
                        <div className="card bg-white shadow py-3" style={{ marginTop: 20 }}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">

                                        <p style={{ color: '#969696' }}>Already have account <a style={{ color: '#0d6efd' }} href="/">Login</a> </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}